import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdBanner, BANNER_GROUPS } from 'src/app/_models/ad-banner';
import { AdBannerService } from 'src/app/_services/ad-banner.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-ad-banner-list',
    templateUrl: './ad-banner-list.component.html',
    styleUrls: ['./ad-banner-list.component.css'],
    standalone: false
})
export class AdBannerListComponent implements OnInit {

    loading = true;
    banners: AdBanner[] = [];
    config: any;
    page = 1;

    constructor(
        private adBannerService: AdBannerService,
        private router: Router,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.loadBanners();
    }

    loadBanners(): void {
        this.loading = true;
        this.adBannerService.loadAll(this.page).subscribe({
            next: (res) => {
                this.banners = res.data;
                this.config = {
                    currentPage: res.page,
                    itemsPerPage: res.itemPerPage,
                    totalItems: res.totalOfItems,
                    totalOfPage: res.totalOfPage,
                    id: 'adBanners'
                };
            },
            error: () => this.loading = false,
            complete: () => this.loading = false
        });
    }

    pageChange(page: number): void {
        this.page = page;
        this.loadBanners();
    }

    imageUrl(imagePath: string): string {
        return environment.image_cdn_url + '/' + imagePath;
    }

    groupLabel(groupValue: string): string {
        const found = BANNER_GROUPS.find(g => g.value === groupValue);
        return found ? found.label : groupValue;
    }

    deleteBanner(banner: AdBanner): void {
        if (!confirm('Are you sure you want to delete this ad banner?')) return;
        this.adBannerService.delete(banner.id).subscribe({
            next: () => {
                this.toastr.success('Ad banner deleted successfully');
                this.loadBanners();
            },
            error: () => this.toastr.error('Failed to delete ad banner')
        });
    }

    navigateAdd(): void {
        this.router.navigate(['/admin', 'ad-banners', 'add']);
    }

    navigateEdit(id: string): void {
        this.router.navigate(['/admin', 'ad-banners', id, 'edit']);
    }
}
